interface OutdoorAfroBadgeProps {
  label?: string;
  className?: string;
}

/**
 * Small "In partnership with Outdoor Afro" trust badge.
 * Rendered as a non-interactive span so it can be safely nested inside
 * card links. The logo is a dark silhouette, so it always sits inside a
 * white chip to stay legible on both light and dark backgrounds.
 */
export default function OutdoorAfroBadge({
  label = 'In partnership with',
  className = '',
}: OutdoorAfroBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 rounded-full bg-white px-3 py-1.5 shadow-sm ring-1 ring-black/5 ${className}`}
    >
      <span className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">
        {label}
      </span>
      <img
        src="/images/outdoor-afro-logo.png"
        alt="Outdoor Afro"
        className="h-6 w-auto"
        loading="lazy"
      />
    </span>
  );
}
